export const REFERRER_TAB = ['relationships'];
